/* Glam Skin — Back in Stock signup · Klaviyo client API · V11.9
   Purpose: a product-specific stock alert only; NOT marketing consent.
   The source site ID is public. No private API credentials are used. */
(() => {
  'use strict';
  const ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/';
  const REVISION = '2026-10-15';

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-glam-bis-form]')) return;
    event.preventDefault();
    if (form.dataset.submitting === 'true' || form.dataset.succeeded === 'true') return;

    const emailInput = form.querySelector('[type="email"]');
    const button = form.querySelector('[type="submit"]');
    const status = form.querySelector('[data-glam-bis-feedback]');
    if (!(emailInput instanceof HTMLInputElement) || !(button instanceof HTMLButtonElement) || !status) return;
    if (!emailInput.reportValidity()) return;

    const variantId = form.dataset.variantId || '';
    const companyId = form.dataset.siteId || '';
    if (!/^\d+$/.test(variantId) || !/^[a-zA-Z0-9]+$/.test(companyId)) {
      status.textContent = form.dataset.errorText || '';
      status.hidden = false;
      return;
    }

    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email: emailInput.value.trim() } } },
          channels: ['EMAIL']
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
        }
      }
    };

    form.dataset.submitting = 'true';
    button.disabled = true;
    form.setAttribute('aria-busy', 'true');
    status.hidden = true;
    try {
      const response = await fetch(ENDPOINT + '?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'revision': REVISION },
        body: JSON.stringify(payload),
        mode: 'cors',
        credentials: 'omit',
        cache: 'no-store'
      });
      if (!response.ok) throw new Error('Klaviyo subscription HTTP ' + response.status);
      form.dataset.succeeded = 'true';
      status.textContent = form.dataset.successText || '';
      status.classList.add('glam-restock__feedback--success');
      emailInput.disabled = true;
      button.hidden = true;
      status.hidden = false;
    } catch (error) {
      status.classList.remove('glam-restock__feedback--success');
      status.textContent = form.dataset.errorText || '';
      status.hidden = false;
      button.disabled = false;
    } finally {
      delete form.dataset.submitting;
      form.removeAttribute('aria-busy');
    }
  });
})();
